module.exports = __webpack_public_path__ + "static/img/xin2.391e23c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/xin2.jpg
// module id = HUQ6
// module chunks = 0